// Port of api/fuel/app/classes/filter/search/games/rules/query/played_with.php
import Rule from 'offline/filter/core/search/rule'
import DB from 'offline/db'
import Util from 'offline/util'

function textInIndex(values) {
	var index = []
	for (var i = 0; i < values.length; i++) {
		var value = String(values[i]).toLowerCase().replace(/'/g, "''")
		index.push("'" + value + "'")
		index.push("'" + value.replace(/-/g, ' ') + "'")
	}
	return index.join(',')
}

export default Rule.create({
	name: 'played_with',
	isIndex: function() { return true },
	field: function() { return 'p.play_id' },
	oneof: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('p.play_id', '=', 0); return }

		var playIds = Util.pluck(DB.query(
			'SELECT DISTINCT play_id FROM play WHERE user_id IN(' + Util.in(data.users) + ')'
		), 'play_id')

		if (!playIds.length) { query.where('p.play_id', '=', 0); return }

		var index = Util.pluck(DB.query(
			'SELECT play_id FROM player WHERE play_id IN(' + Util.in(playIds) + ') AND LOWER(player_name) IN(' + textInIndex(values) + ')'
		), 'play_id')

		var result = Rule.setFilter(rule, 'one', index)
		var opMap = Rule.operandMapped(rule, { '=': 'in', '!=': 'not in' })
		query.where('p.play_id', opMap, result)
	},
	someof: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('p.play_id', '=', 0); return }

		var playIds = Util.pluck(DB.query(
			'SELECT DISTINCT play_id FROM play WHERE user_id IN(' + Util.in(data.users) + ')'
		), 'play_id')

		if (!playIds.length) { query.where('p.play_id', '=', 0); return }

		var index = Util.pluck(DB.query(
			'SELECT play_id FROM player WHERE play_id IN(' + Util.in(playIds) + ') AND LOWER(player_name) IN(' + textInIndex(values) + ')'
		), 'play_id')

		query.where('p.play_id', 'in', Rule.setFilter(rule, 'some', index))
	},
	allof: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('p.play_id', '=', 0); return }

		var playIds = Util.pluck(DB.query(
			'SELECT DISTINCT play_id FROM play WHERE user_id IN(' + Util.in(data.users) + ')'
		), 'play_id')

		if (!playIds.length) { query.where('p.play_id', '=', 0); return }

		var index = Util.pluck(DB.query(
			'SELECT play_id FROM player WHERE play_id IN(' + Util.in(playIds) + ') AND LOWER(player_name) IN(' + textInIndex(values) + ')'
		), 'play_id')

		query.where('p.play_id', 'in', Rule.setFilter(rule, 'all', index))
	},
	match: function(rule, config, filter, data, query) {
		var values = Rule.value(rule)
		if (!values || !values.length) { query.where('p.play_id', '=', 0); return }

		var playIds = Util.pluck(DB.query(
			'SELECT DISTINCT play_id FROM play WHERE user_id IN(' + Util.in(data.users) + ')'
		), 'play_id')

		if (!playIds.length) { query.where('p.play_id', '=', 0); return }

		var index = Util.pluck(DB.query(
			'SELECT play_id FROM player WHERE play_id IN(' + Util.in(playIds) + ') AND LOWER(player_name) IN(' + textInIndex(values) + ')'
		), 'play_id')

		var result = Rule.setFilter(rule, 'one', index)
		var opMap = Rule.operandMapped(rule, { '=': 'in', '!=': 'not in' })
		query.where('p.play_id', opMap, result)
	}
})
